module.exports = __webpack_public_path__ + "static/media/widget-remove-example.870ccf1e.png";